import { scroll } from "motion";

export class ProjectColorize {
	constructor() {
		this.items = document.querySelectorAll(".project-item");
		if (!this.items.length) return;

		this.cleanups = [];
		this.init();

		window.addEventListener("projects-filtered", () => {
			this.destroy();
			this.init();
		});
	}

	init() {
		this.items.forEach((item) => {
			const carousel = item.querySelector(".project-item__carousel");

			const cleanup = scroll(
				(progress) => {
					let grayscale;
					if (progress < 0.15) {
						grayscale = 100;
					} else if (progress < 0.3) {
						grayscale = (1 - (progress - 0.15) / 0.15) * 100;
					} else if (progress < 0.7) {
						grayscale = 0;
					} else {
						grayscale = Math.min(((progress - 0.7) / 0.1) * 100, 100);
					}
					item.style.setProperty("--grayscale", grayscale);
				},
				{ target: carousel, offset: ["start end", "end start"] }
			);

			this.cleanups.push(cleanup);
		});
	}

	destroy() {
		this.cleanups.forEach((cleanup) => cleanup());
		this.cleanups = [];
	}
}
